import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Modal.css";

import { AiOutlineCloseCircle } from 'react-icons/ai'


const Modalform = ({ open, onClose }) => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_y8m0r7g",
                "template_3jbw8ed",
                form.current,
                "RkTm2MMUEG9cjtF-H"
            )
            .then(
                (result) => {
                    console.log(result.text);
                    alert("Wiadomość wysłana!");
                },
                (error) => {
                    console.log(error.text);
                    alert("FAILED...", error);
                }
            );
    };

    if (!open) return null;
    return (
        <div onClick={onClose} className="overlay">
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                className="modalContainer"
            >
                <div className="modalRight">
                    <p className="closeBtn" onClick={onClose}>
                        <AiOutlineCloseCircle />
                    </p>

                    <div className="content">
                        <h1 className="h1-modal">
                            Zapisz się na pierwszą konsultację
                        </h1>
                        <form ref={form} onSubmit={sendEmail}>
                            <div className="app__flex">
                                {/* <label>Imie i Nazwisko</label> */}
                                <input
                                    required
                                    className="p-text"
                                    type="name"
                                    name="user_name"
                                    id="name"
                                    placeholder="Imię i nazwisko"
                                />
                            </div>

                            <div className="app__flex">
                                {/* <label>Email</label> */}
                                <input
                                    required
                                    className="p-text"
                                    type="email"
                                    name="user_email"
                                    id="email"
                                    placeholder="Email"
                                />
                            </div>

                            <div className="app__flex">
                                {/* <label>Telefon</label> */}
                                <input
                                    required
                                    className="p-text"
                                    type="text"
                                    name="user_phone"
                                    id="number"
                                    placeholder="Numer kontaktowy"
                                />
                            </div>

                            <div className="app__flex">
                                {/* <label>Temat</label> */}
                                <input
                                    required
                                    className="p-text"
                                    type="text"
                                    name="user_subject"
                                    id="subject"
                                    placeholder="Wpisz temat"
                                />
                            </div>

                            <div className="app__flex">
                                {/* <label>Wiadomość</label> */}
                                <textarea
                                    required
                                    className="p-text_a"
                                    name="user_message"
                                    id="email_body"
                                    placeholder="Twoja wiadomość"
                                />
                            </div>
                            <div className="btnform">
                                <button type="submit" class="form_btn">
                                    Wyślij
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modalform;
